/**
 * Set cookie
 * @param {string} cname
 * @param {string} cvalue
 */
export const CookieSet = (cname, cvalue) => {
    const exdays = 40;
    const d = new Date();
    d.setTime(Date.now() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

/**
 * Get cookie
 * @param {string} cname
 */
export const CookieGet = (cname) => {
    // noinspection JSCheckFunctionSignatures
    const Cookie = document.cookie
        .split(';')
        .find((item) => item.includes(cname)) || '';
    return Cookie.split('=').length > 0 && Cookie.split('=')[1] ? Cookie.split('=')[1].trim() : '';
}

/**
 * Remove cookie
 * @param {string} cname
 */
export const CookieRemove = (cname) => {
    const exdays = 40;
    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * -1);
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${cname}=;${expires};path=/`;
}